import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Avatar} from "primereact/avatar";
import {Button} from "primereact/button";
import {Card} from "primereact/card";
import {useTranslate} from "../useTranslate";
import {check} from "../../auth/auth-slice";
import {getAdminRoleLabels} from "../admin-access";

function AdminAccessDenied({
    titleKey = "admin-access-denied-title",
    descriptionKey = "admin-access-denied-description",
}) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const [checking, setChecking] = useState(false);
    const roles = getAdminRoleLabels(user);
    const loadFailed = Boolean(user?.permissionsError);

    // reload roles and permissions from the server (a temporary failure must not keep an admin locked out)
    const retry = async () => {
        setChecking(true);
        try {
            await dispatch(check());
        } finally {
            setChecking(false);
        }
    };

    return (
        <div className="w-full h-full flex align-items-center justify-content-center p-3 rtl text-xs">
            <Card
                className="w-full md:w-30rem border-1 border-orange-200 shadow-none"
                pt={{body: {className: "p-4"}, content: {className: "p-0"}}}
            >
                <div className="flex flex-column align-items-center text-center gap-3">
                    <Avatar
                        icon="pi pi-lock"
                        size="xlarge"
                        shape="circle"
                        className="bg-orange-50 text-orange-600"
                    />
                    <span className="text-base font-bold text-900">{translate(titleKey)}</span>
                    <span className="text-xs text-600 line-height-3">
                        {loadFailed ? "مجوزهای شما از سرور دریافت نشد (خطای موقت شبکه یا سرور)." : translate(descriptionKey)}
                    </span>
                    <span className="text-2xs text-500">
                        نقش‌های این حساب: {roles.length ? roles.join("، ") : "هیچ نقشی دریافت نشد"}
                        {" · "}مجوزها: {(user?.permissions || []).length}
                    </span>
                    <Button label="تلاش دوباره" icon="pi pi-refresh" size="small" className="text-xs gap-1" loading={checking} onClick={retry}/>
                </div>
            </Card>
        </div>
    );
}

export default AdminAccessDenied;
